export default __webpack_public_path__ + "static/media/alamo-material-4.d8b9e2c2.webp";